import { Text } from "./MessageStyled";

export const Message = ({ text }) => {
  return <Text>{text}</Text>;
};
